import { render, staticRenderFns } from "./reviewManage.vue?vue&type=template&id=7c330349&scoped=true&"
import script from "./reviewManage.vue?vue&type=script&lang=js&"
export * from "./reviewManage.vue?vue&type=script&lang=js&"
import style0 from "./reviewManage.vue?vue&type=style&index=0&id=7c330349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c330349",
  null
  
)

export default component.exports